import React, { Component } from 'react';
import FirstPageGSTPurchaseEntry from '../../components/account/GSTPurchaseEntryRMPM/FirstPageGSTPurchaseEntry.js';
import ItemForm1 from '../../components/account/GSTPurchaseEntryRMPM/ItemForm1.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import ItemTable from '../../components/account/GSTPurchaseEntryRMPM/ItemTable.js';
import HSNCodeTableForm from '../../components/account/GSTPurchaseEntryRMPM/HSNCodeTableForm.js';
import PaymentSummary from '../../components/account/GSTPurchaseEntryRMPM/PaymentSummary.js';
import ItemDetailsModel from '../../components/account/GSTPurchaseEntryRMPM/ItemDetailsModel.js';
import ItemForm2 from '../../components/account/GSTPurchaseEntryRMPM/ItemForm2.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import moment from 'moment';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class GstPurchaseEntryRMPM extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            index: null,
            isGridView: true,
            isEditing: false,
            isLoading: false,
            tableStatus: "",
            setItemDetailsModel: false,
            validationTextForGRNEntry: '',
            pendingGRNPurchaseEntryList: [],
            gstPurchaseEntryRMPMList: [],
            filterDetails: {
                partyName: "",
                arrangedBy: "Select",
            },
            invoiceDetails: {
                gstPurchaseEntryRMPMId: "",
                srNo: "",
                invoiceNo: "",
                invoiceDate: "",
                reptDate: "",
                partyId: "",
                partyName: "",
                freight: "",
                other: "",
                roundOff: "",
                subTotal: "",
                sgst: "",
                cgst: "",
                igst: "",
                ugst: "",
                grandTotal: "",
                remarks: "",
                pendingAmount: ""
            },
            itemDetails: {
                grnPartyDetailsId: '',
                grnMaterialId: '',
                grnNo: '',
                other: '',
                rawMaterialId: '',
                packageMaterialId: '',
                itemId: '',
                itemName: '',
                batchNo: '',
                qty: 0,
                rate: 0,
                amount: 0,
                hsnCodeId: '',
                hsnCodeName: '',
                sgst: 0,
                cgst: 0,
                igst: 0,
                ugst: 0,
                taxableAmount: 0,
                sgstAmount: 0,
                cgstAmount: 0,
                ugstAmount: 0,
                igstAmount: 0,
            },
            partyDropdownList: [],
            itemListing: [],
            rawMaterialList: [],
            packingMaterialDropDownList: [],
            hsnCodeList: [],
            hsnCodeListForTable: [],
            arrangedByList: [
                { arrangedBy: "Ser. No.", value: "srNo" },
                { arrangedBy: "Invoice No.", value: "invoiceNo" },
                { arrangedBy: "Invoice Date", value: "invoiceDate" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Net Amount", value: "grandTotal" },
            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                invoiceNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice No"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForItemDetails: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                hsnCodeName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "hsn Code"
                        ),
                    },
                ],
            },
            validStateForItemDetails: {
                isValid: true,
                error: {},
            },

        };
    };


    componentDidMount() {
        this.getAllGSTPurchaseEntryRMPM()
    }

    getAllGSTPurchaseEntryRMPM = () => {
        this.setState({ tableStatus: "Loading..." }, () => {
            let request = this.state.filterDetails
            this.accountServices.getAllGSTPurchaseEntryRMPM(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    this.setState({ gstPurchaseEntryRMPMList: response.responseData }, () => {
                        this.getAllPartyDropdown()
                    })
                } else {
                    this.setState({ tableStatus: "" })
                    this.getAllPartyDropdown();
                    this.SwalServices.Error(response.Message);
                }
            });
        })
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllRMDropdown()
                });
            } else {
                this.getAllRMDropdown()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllRMDropdown = () => {
        this.commonServices.getAllRMDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.rmName,
                    value: item._id,
                    uom: item.rmUOM
                }));
                this.setState({ rawMaterialList: dropdownItems }, () => {
                    this.getAllHSNCode()
                });
            } else {
                this.getAllHSNCode()
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPackingMaterialDropdown = () => {
        this.commonServices.getAllPackingMaterialDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.pmName,
                    value: item._id,
                    uom: item.pmUOM
                }));
                this.setState({ packingMaterialDropDownList: dropdownItems }, () => { });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST
                }));
                this.setState({ hsnCodeList: dropdownItems }, () => {
                    this.getAllPackingMaterialDropdown()
                });
            } else {
                this.SwalServices.Error(response.Message);
                this.getAllPackingMaterialDropdown()
            }
        });
    };
    getGSTPurchseEntryInvoiceNo = () => {
        this.closeGridView()
    }

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.error = {}
        validState.isValid = true
        let Fdetails = this.state.filterDetails;
        Fdetails.partyName = "";
        Fdetails.arrangedBy = "Select";

        let Idetails = this.state.invoiceDetails;
        Idetails.gstPurchaseEntryRMPMId = "";
        Idetails.srNo = "";
        Idetails.invoiceNo = "";
        Idetails.invoiceDate = "";
        Idetails.reptDate = "";
        Idetails.partyId = "";
        Idetails.freight = "";
        Idetails.other = "";
        Idetails.roundOff = "";
        Idetails.subTotal = "";
        Idetails.sgst = "";
        Idetails.cgst = "";
        Idetails.igst = ""
        Idetails.ugst = ""
        Idetails.grandTotal = ""
        Idetails.remarks = "";
        Idetails.pendingAmount = "";
        this.setState({
            invoiceDetails: Idetails, filterDetails: Fdetails, noItemFound: "", validState: validState, itemListing: [], hsnCodeListForTable: []
        }, () => {
            this.getAllGSTPurchaseEntryRMPM()
        }, () => {
            this.resetItemDetailsForm()
        });
    };

    resetItemDetailsForm = () => {
        let validStateForItemDetails = this.state.validStateForItemDetails
        validStateForItemDetails.isValid = true
        validStateForItemDetails.error = {}
        let details = this.state.itemDetails
        details.itemId = ''
        details.itemName = ''
        details.grnNo = ''
        details.batchNo = ''
        details.qty = 0
        details.rate = 0
        details.amount = 0
        details.taxableAmount = 0
        details.hsnCodeId = ''
        details.hsnCodeName = ''
        details.sgst = 0
        details.cgst = 0
        details.igst = 0
        details.ugst = 0
        details.sgstAmount = 0
        details.cgstAmount = 0
        details.igstAmount = 0
        details.ugstAmount = 0
        this.setState({ itemDetails: details, validStateForItemDetails: validStateForItemDetails })
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.invoiceDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    openPopUpForAddingItem = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let request = {
                partyId: this.state.invoiceDetails.partyId,
                invoiceNo: this.state.invoiceDetails.invoiceNo
            }
            this.accountServices.getAllPendingGRNPurchaseEntry(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    if (response.responseData.length === 0) {
                        this.setState({ validationTextForGRNEntry: `There are no pending GRNs for Invoice: ${this.state.invoiceDetails.invoiceNo}, Party: ${this.state.invoiceDetails.partyName}.` })
                    } else {
                        this.setState({ validationTextForGRNEntry: '' })
                    }
                    this.setState({ pendingGRNPurchaseEntryList: response.responseData }, () => {
                        this.resetItemDetailsForm()
                        this.setState({ setItemDetailsModel: true })
                    });
                } else {
                    this.SwalServices.Error(response.Message);
                }
            });
        }
    };

    setOpenModel = () => {
        this.setState({ setItemDetailsModel: !this.state.setItemDetailsModel });
    };
    closePopUp = () => {
        this.setState({ setItemDetailsModel: false, index: null },
            // () => {
            //     this.resetItemDetailsForm()
            // }
        )
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllGSTPurchaseEntryRMPM()
            });
        } else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = value.toUpperCase();
            if (name === 'freight' || name === 'other' || name === 'roundOff') {
                this.calculateGrandTotal()
            }
            this.setState({ invoiceDetails: details });
        }
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details }, () => {
            this.getAllGSTPurchaseEntryRMPM()
        });
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.invoiceDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.partyName = selected.label
        }
        this.setState({ invoiceDetails: details });
    };
    setFilterParametersForItemTable = (selected, fieldName) => {
        let details = this.state.itemDetails;
        details[fieldName] = selected.value;
        if (fieldName === 'itemId') {
            details.packing = selected.packing
            details.itemName = selected.label
        }
        if (fieldName === 'hsnCodeId') {
            details.hsnCodeName = selected.label
            details.sgst = selected.sgstRate
            details.cgst = selected.cgstRate
            details.igst = selected.igstRate
            details.ugst = selected.utgstRate
        }
        this.setState({ itemDetails: details }, () => {
            this.calculateItemAmount()
        });
    };

    // Safely convert any value (string, undefined, null, NaN) to a rounded number.
    // Always returns a finite number so calculations never produce NaN.
    toNum = (value, decimals = 2) => {
        const num = Number(value);
        if (!Number.isFinite(num)) {
            return 0;
        }
        return Number(num.toFixed(decimals));
    }

    calculateItemAmount = () => {
        let itemDetails = this.state.itemDetails
        itemDetails.amount = this.toNum(this.toNum(itemDetails.qty) * this.toNum(itemDetails.rate))
        itemDetails.taxableAmount = this.toNum(this.toNum(itemDetails.amount) + this.toNum(itemDetails.other))
        itemDetails.sgstAmount = this.toNum(this.toNum(itemDetails.sgst) * this.toNum(itemDetails.taxableAmount) / 100)
        itemDetails.cgstAmount = this.toNum(this.toNum(itemDetails.cgst) * this.toNum(itemDetails.taxableAmount) / 100)
        itemDetails.igstAmount = this.toNum(this.toNum(itemDetails.igst) * this.toNum(itemDetails.taxableAmount) / 100)
        itemDetails.ugstAmount = this.toNum(this.toNum(itemDetails.ugst) * this.toNum(itemDetails.taxableAmount) / 100)
        this.setState({ itemDetails: itemDetails })
    }

    handleChangeForItemTable = (event, fieldName) => {
        let value = event.target.value
        let details = this.state.itemDetails;
        details[fieldName] = value;
        this.setState({ itemDetails: details }, () => {
            this.calculateItemAmount()
        });
    };

    getGSTPurchseEntrySRNo = () => {
        this.accountServices.getGSTPurchseEntrySRNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.invoiceDetails
                details.srNo = response.responseData.srNo
                details.invoiceDate = moment(new Date()).format('yyyy-MM-DD')
                details.reptDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ contraDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    selectPendingGRNEntry = (item) => {
        let details = this.state.itemDetails
        details.grnMaterialId = item._id
        details.grnPartyDetailsId = item.grnEntryPartyDetailId._id
        details.packageMaterialId = item.packageMaterialId ? item.packageMaterialId._id : null
        details.rawMaterialId = item.rawMaterialId ? item.rawMaterialId._id : null
        details.itemId = item.rawMaterialId ? item.rawMaterialId._id : item.packageMaterialId._id
        details.itemName = item.packageMaterialId ? item.packageMaterialId.pmName : item.rawMaterialId.rmName
        details.grnType = item.packageMaterialId ? 'Packing' : 'Raw'
        details.batchNo = item.batchNo
        details.qty = item.qty
        details.rate = item.rate
        details.amount = item.amount
        details.grnNo = item.grnEntryPartyDetailId.grnNo
        this.setState({ itemDetails: details }, () => {
            this.getLastPurchaseRawmaterialRate(item.rawMaterialId ? item.rawMaterialId._id : item.packageMaterialId._id, item.rawMaterialId ? 'Raw' : 'Packing')
            this.setState({ pendingGRNPurchaseEntryList: [] })
        })
    }

    getLastPurchaseRawmaterialRate = (rawMaterialId, grnType) => {
        let request = [rawMaterialId, grnType]
        this.accountServices.getLastPurchaseRawmaterialRate(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData.lastPurchasedRecord
                if (res) {
                    let details = this.state.itemDetails
                    details.rate = res.rate
                    details.hsnCodeName = res.hsnCodeName
                    details.sgst = res.sgst
                    details.cgst = res.cgst
                    details.igst = res.igst
                    details.ugst = res.ugst
                    this.setState({ itemDetails: details }, () => {
                        this.calculateItemAmount()
                    });
                }
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    updateGRNEntryToPurchaseEntry = (grnMaterialId, grnPartyDetailsId, isGRNEntryDone) => {
        let request = {
            grnMaterialId: grnMaterialId,
            grnPartyDetailsId: grnPartyDetailsId,
            isGRNEntryDone: isGRNEntryDone
        }
        this.accountServices.updateGRNEntryToPurchaseEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                // GRN Entry Updated
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    isValidAllFieldsForItemDetails = () => {
        const newValidState = isValidForm(
            this.state.itemDetails,
            this.state.validationRulesForItemDetails,
            this.state.validStateForItemDetails
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };


    addItemToItemArray = () => {
        let isValidAllFieldsForItemDetails = this.isValidAllFieldsForItemDetails();
        if (isValidAllFieldsForItemDetails) {
            let itemListing = [...this.state.itemListing];
            let details = { ...this.state.itemDetails }
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                itemListing[this.state.index] = details
            } else {
                itemListing.push(details);
            }
            this.setState({ itemListing: itemListing, setItemDetailsModel: false }, () => {
                this.setState({ index: null, isEditing: false })
                // this.updateGRNEntryToPurchaseEntry(this.state.itemDetails.grnMaterialId, this.state.itemDetails.grnPartyDetailsId, true)
                this.showHSNCodes()
            })
        }
    }

    showHSNCodes = () => {
        const { itemListing } = this.state;

        const filtered = itemListing.map(({ hsnCodeName, taxableAmount, sgst, sgstAmount, cgst, cgstAmount, igst, igstAmount, ugst, ugstAmount }) => ({
            hsnCodeName,
            taxableAmount,
            sgst,
            sgstAmount,
            cgst,
            cgstAmount,
            igst,
            igstAmount,
            ugst,
            ugstAmount
        }));

        this.setState({ hsnCodeListForTable: filtered }, () => {
            this.calculateGrandTotal()
        });
    }

    calculateGrandTotal = () => {
        let list = this.state.hsnCodeListForTable

        const totals = list.reduce(
            (acc, item) => {
                acc.sgstAmount += this.toNum(item.sgstAmount);
                acc.cgstAmount += this.toNum(item.cgstAmount);
                acc.igstAmount += this.toNum(item.igstAmount);
                acc.ugstAmount += this.toNum(item.ugstAmount);
                acc.taxableAmount += this.toNum(item.taxableAmount);
                return acc;
            },
            { sgstAmount: 0, cgstAmount: 0, igstAmount: 0, ugstAmount: 0, taxableAmount: 0 }
        );

        let details = this.state.invoiceDetails
        details.subTotal = this.toNum(totals.taxableAmount).toFixed(2)
        details.sgst = this.toNum(totals.sgstAmount).toFixed(2)
        details.cgst = this.toNum(totals.cgstAmount).toFixed(2)
        details.igst = this.toNum(totals.igstAmount).toFixed(2)
        details.ugst = this.toNum(totals.ugstAmount).toFixed(2)
        let grandTotal = this.toNum(this.toNum(details.subTotal) + this.toNum(details.sgst) + this.toNum(details.igst) + this.toNum(details.cgst))
        grandTotal = this.toNum(grandTotal + this.toNum(details.freight) + this.toNum(details.other))
        details.roundOff = this.toNum(grandTotal % 1).toFixed(2);
        details.grandTotal = Math.round(grandTotal).toFixed(2);
        details.pendingAmount = Math.round(grandTotal)
        this.setState({ invoiceDetails: details })
    }

    deleteItemById = (index, isFromDB) => {
        let list = [...this.state.itemListing];
        list.splice(index, 1);
        this.setState({ itemListing: list }, () => {
            if (!isFromDB) {
                this.updateGRNEntryToPurchaseEntry(this.state.itemDetails.grnMaterialId, this.state.itemDetails.grnPartyDetailsId, false)
            }
            this.showHSNCodes()
        });
    }

    addEditGSTPurchaseEntryRMPM = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                if (this.state.itemListing.length > 0) {
                    let request = {
                        invoiceDetails: this.state.invoiceDetails,
                        itemListing: this.state.itemListing
                    }
                    this.accountServices.addEditGSTPurchaseEntryRMPM(request).then((response) => {
                        if (response.statusCode === 200 && response.responseData != null) {
                            let details = this.state.invoiceDetails
                            details.gstPurchaseEntryRMPMId = response.responseData.invoiceDetails._id
                            this.setState({ invoiceDetails: details, isLoading: false })
                            this.SwalServices.Success(response.Message)
                            this.openGridView()
                        } else {
                            this.setState({ isLoading: false })
                            this.SwalServices.Error(response.Message);
                            this.openGridView()
                        }
                    });

                } else {
                    this.setState({ isLoading: false })
                    this.SwalServices.Alert('No records found. Please add item to proceed.')
                }
            })
        }
    }

    getGSTPurchaseEntryRMPMById = (id,) => {
        this.accountServices.getGSTPurchaseEntryRMPMById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.invoiceDetails
                details.srNo = res.invoiceDetails.srNo
                details.gstPurchaseEntryRMPMId = res.invoiceDetails._id
                details.invoiceNo = res.invoiceDetails.invoiceNo
                details.invoiceDate = moment(res.invoiceDetails.invoiceDate).format('yyyy-MM-DD')
                details.reptDate = moment(res.invoiceDetails.reptDate).format('yyyy-MM-DD')
                details.partyId = res.invoiceDetails.partyId._id
                details.partyName = res.invoiceDetails.partyId.partyName
                details.freight = res.invoiceDetails.freight
                details.other = res.invoiceDetails.other
                details.roundOff = res.invoiceDetails.roundOff
                details.subTotal = res.invoiceDetails.subTotal
                details.sgst = res.invoiceDetails.sgst
                details.cgst = res.invoiceDetails.cgst
                details.igst = res.invoiceDetails.igst
                details.ugst = res.invoiceDetails.ugst
                details.grandTotal = Number(res.invoiceDetails.grandTotal).toFixed(2)
                details.pendingAmount = res.invoiceDetails.pendingAmount

                let list = res.itemListing
                list.map(item => {
                    item.isFromDB = true
                    return item
                })
                this.setState({ invoiceDetails: details, itemListing: list }, () => {
                    this.showHSNCodes()
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteGSTPurchaseEntryRMPMById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Purchase Entry?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteGSTPurchaseEntryRMPMById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllGSTPurchaseEntryRMPM()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    editItemDetails = (index) => {
        let list = this.state.itemListing
        let itemDetails = this.state.itemDetails
        let item = list[index];
        itemDetails.gstPurchaseEntryRMPMId = item.gstPurchaseEntryRMPMId
        itemDetails.itemId = item.itemId
        itemDetails.grnType = item.packageMaterialId ? 'Packing' : 'Raw'
        itemDetails.rawMaterialId = item.rawMaterialId ? item.rawMaterialId : null
        itemDetails.packageMaterialId = item.packageMaterialId ? item.packageMaterialId : null
        itemDetails.grnNo = item.grnNo
        itemDetails.grnMaterialId = item.grnMaterialId
        // itemDetails._id = item._id
        itemDetails.grnPartyDetailsId = item.grnPartyDetailsId
        itemDetails.itemName = item.itemName
        itemDetails.batchNo = item.batchNo
        itemDetails.qty = item.qty
        itemDetails.rate = item.rate
        itemDetails.amount = item.amount
        itemDetails.taxableAmount = item.taxableAmount
        itemDetails.hsnCodeId = item.hsnCodeId
        itemDetails.hsnCodeName = item.hsnCodeName
        itemDetails.sgst = item.sgst
        itemDetails.cgst = item.cgst
        itemDetails.igst = item.igst
        itemDetails.ugst = item.ugst
        itemDetails.sgstAmount = item.sgstAmount
        itemDetails.cgstAmount = item.cgstAmount
        itemDetails.igstAmount = item.igstAmount
        itemDetails.ugstAmount = item.ugstAmount
        itemDetails.other = item.other
        // let selected = {
        //     value: item.itemId,
        //     packing: item.packing,
        //     label: item.itemName
        // }
        // this.setFilterParametersForItemTable(selected, 'itemId')
        this.setState({ itemDetails: itemDetails, index: index }, () => {
            this.setState({ setItemDetailsModel: true, isEditing: true })
        })
    }

    render() {
        return (
            <>
                <div className='firstPageGSTPurchaseEntry-page'>
                    {/* First page  */}
                    {this.state.isGridView === true ? (
                        <FirstPageGSTPurchaseEntry
                            filterDetails={this.state.filterDetails}
                            handleChange={this.handleChange.bind(this)}
                            arrangedByList={this.state.arrangedByList}
                            handleDropDownChange={this.handleDropDownChange.bind(this)}
                            getGSTPurchseEntryInvoiceNo={this.getGSTPurchseEntryInvoiceNo.bind(this)}
                            getGSTPurchseEntrySRNo={this.getGSTPurchseEntrySRNo.bind(this)}
                            gstPurchaseEntryRMPMList={this.state.gstPurchaseEntryRMPMList}
                            getGSTPurchaseEntryRMPMById={this.getGSTPurchaseEntryRMPMById.bind(this)}
                            deleteGSTPurchaseEntryRMPMById={this.deleteGSTPurchaseEntryRMPMById.bind(this)}
                            tableStatus={this.state.tableStatus}
                        />
                    ) : null}

                    {this.state.isGridView === false ? (
                        <div>
                            {/* 1. Item Form  */}
                            <ItemForm1
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                                validState={this.state.validState}
                                partyDropdownList={this.state.partyDropdownList}
                                setFilterParameters={this.setFilterParameters.bind(this)}
                            />
                            {/* 2.  Item tabel  */}
                            <ItemTable
                                itemListing={this.state.itemListing}
                                openPopUpForAddingItem={this.openPopUpForAddingItem.bind(this)}
                                hsnCodeList={this.state.hsnCodeList}
                                deleteItemById={this.deleteItemById.bind(this)}
                                editItemDetails={this.editItemDetails.bind(this)}
                            />
                            {/* 3. Table & Sections  */}
                            <div className="flex  gap-2.5 mb-4">
                                <HSNCodeTableForm
                                    hsnCodeListForTable={this.state.hsnCodeListForTable}
                                    invoiceDetails={this.state.invoiceDetails}
                                    handleChange={this.handleChange.bind(this)}
                                />
                                <PaymentSummary
                                    invoiceDetails={this.state.invoiceDetails}
                                    handleChange={this.handleChange.bind(this)}

                                />
                            </div>
                            <hr />

                            {/*4. Item form   */}
                            <ItemForm2
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                            />
                            <div className="btn-grp flex gap-2.5 mt-4">
                                <button
                                    className="add-btn"
                                    onClick={() => this.addEditGSTPurchaseEntryRMPM()}
                                    disabled={this.state.isLoading}
                                >
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                </button>
                                <button
                                    className="cancel-btn"
                                    onClick={() => this.openGridView()}
                                    disabled={this.state.isLoading}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    ) : null}
                </div>

                <ItemDetailsModel
                    setItemDetailsModel={this.state.setItemDetailsModel}
                    setOpenModel={this.setOpenModel.bind(this)}
                    hsnCodeList={this.state.hsnCodeList}
                    rawMaterialList={this.state.rawMaterialList}
                    packingMaterialDropDownList={this.state.packingMaterialDropDownList}
                    setFilterParametersForItemTable={this.setFilterParametersForItemTable.bind(this)}
                    handleChangeForItemTable={this.handleChangeForItemTable.bind(this)}
                    itemDetails={this.state.itemDetails}
                    validState={this.state.validState}
                    closePopUp={this.closePopUp.bind(this)}
                    isEditing={this.state.isEditing}
                    pendingGRNPurchaseEntryList={this.state.pendingGRNPurchaseEntryList}
                    selectPendingGRNEntry={this.selectPendingGRNEntry.bind(this)}
                    addItemToItemArray={this.addItemToItemArray.bind(this)}
                    validationTextForGRNEntry={this.state.validationTextForGRNEntry}
                />
            </>
        );
    }
}

export default GstPurchaseEntryRMPM;